"use client";

import * as React from "react";

import type { CalculatorFormatters } from "@/lib/pricing-calculator/format";
import { createFormatters } from "@/lib/pricing-calculator/format";

export interface CalculatorEnvironment {
  locale: string;
  currency: string;
  currencySymbol: string;
  format: CalculatorFormatters;
}

const CalculatorContext = React.createContext<CalculatorEnvironment | null>(
  null
);

export function CalculatorProvider({
  locale,
  currency,
  currencySymbol,
  children,
}: {
  locale: string;
  currency: string;
  currencySymbol: string;
  children: React.ReactNode;
}) {
  const value = React.useMemo<CalculatorEnvironment>(
    () => ({
      locale,
      currency,
      currencySymbol,
      format: createFormatters(locale, currency),
    }),
    [locale, currency, currencySymbol]
  );
  return (
    <CalculatorContext.Provider value={value}>
      {children}
    </CalculatorContext.Provider>
  );
}

export function useCalculatorEnvironment(): CalculatorEnvironment {
  const value = React.useContext(CalculatorContext);
  if (!value) {
    throw new Error("useCalculatorEnvironment requires CalculatorProvider");
  }
  return value;
}
